import { TableCell } from "@mui/material";

export const CustomTableCell = ({ field, align, sx = {} }) => {
  return (
    <TableCell
      align={align}
      title={field}
      sx={{ 
        fontSize: 12, 
        whiteSpace: 'nowrap',
        maxWidth: '200px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...sx 
      }}
    >
      {field}
    </TableCell>
  );
};